function cancellationDateToggle() {
    const radios = document.querySelectorAll('input[name="cancellation_timing"]');
    const dateWrapper = document.querySelector('.js-cancellation-date-wrapper');

    if (!radios.length || !dateWrapper) {
        return;
    }

    function toggleDateField() {
        const selected = document.querySelector('input[name="cancellation_timing"]:checked');
        if (selected && selected.value === 'specific_date') {
            dateWrapper.style.display = '';
        } else {
            dateWrapper.style.display = 'none';
        }
    }

    toggleDateField();

    radios.forEach((radio) => {
        radio.addEventListener('change', toggleDateField);
    });
}

window.addEventListener('load', cancellationDateToggle);
